import { useRef } from "react";
import { ResultOf } from "gql.tada";
import { MediaGallerySectionById } from "../../queries/entries/MediaGallerySectionById";
import MediaGallery from "../shared/MediaGallery";

export const MediaGallerySection = ({
  entry: { mediaGallerySection: entry },
}: {
  entry: ResultOf<typeof MediaGallerySectionById>
}) => {
  const ref = useRef<HTMLDivElement>(null);

  if (!entry || !entry?.mediaItemsCollection) return null;
  const mediaItems = entry.mediaItemsCollection.items;

  const slides = mediaItems.map((i) => ({
    mediaUrl: i?.itemMedia?.url ?? "",
    contentType: i?.itemMedia?.contentType ?? "",
  }));

  return (
    <div
      className="py-10 flex-col justify-start dsk:gap-10 relative"
      ref={ref}
    >
      <div className="overflow-hidden flex justify-center items-center h-60 dsk:h-[450px]">
        <MediaGallery
          items={slides}
          containerRef={ref}
          itemClassName="w-full h-full object-cover rounded-lg"
        />
      </div>
    </div>
  )
}
